import {
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { getStringHashCode26igk1bx568vk as getStringHashCode } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var DispatcherClass;
function Dispatcher() {
  if (DispatcherClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'Dispatcher', VOID, VOID, VOID, [1]);
    DispatcherClass = $;
  }
  return DispatcherClass;
}
var GrantDiscordAccessCommandClass;
function GrantDiscordAccessCommand() {
  if (GrantDiscordAccessCommandClass === VOID) {
    class $ {
      constructor(code, guildId, partyId) {
        this.y2i_1 = code;
        this.z2i_1 = guildId;
        this.a2j_1 = partyId;
      }
      toString() {
        return 'GrantDiscordAccessCommand(code=' + this.y2i_1 + ', guildId=' + this.z2i_1 + ', partyId=' + this.a2j_1.toString() + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.y2i_1);
        result = imul(result, 31) + getStringHashCode(this.z2i_1) | 0;
        result = imul(result, 31) + this.a2j_1.hashCode() | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof GrantDiscordAccessCommand()))
          return false;
        if (!(this.y2i_1 === other.y2i_1))
          return false;
        if (!(this.z2i_1 === other.z2i_1))
          return false;
        if (!this.a2j_1.equals(other.a2j_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'GrantDiscordAccessCommand');
    GrantDiscordAccessCommandClass = $;
  }
  return GrantDiscordAccessCommandClass;
}
//region block: exports
export {
  Dispatcher as Dispatcher27uwezb7p8fpg,
  GrantDiscordAccessCommand as GrantDiscordAccessCommand2guwl3gyfjco,
};
//endregion

//# sourceMappingURL=GrantDiscordAccessCommand.mjs.map
